var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('enterprises.title')))]),_c('br'),_c('custom-table',{attrs:{"icon":"mdi-cellphone-android","title":"enterprises.title","headers":[{
        text: _vm.$t('enterprises.name'),
        align: 'left',
        sortable: false,
        value: 'ident',
      },
      { text: _vm.$t('enterprises.domain'), value: 'domain' },
      { text: 'Carta externa', value: 'externalPDF' },
      { text: '',
        align: 'left',
        sortable: false,
        value: 'actions' } ],"data":_vm.data,"count":_vm.count,"loading":_vm.loading,"onAdd":_vm.handleAdd,"onSearch":_vm.handleChangeSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }